export const aiPromptsKeys = {
  all: ['aiPrompts'] as const,
  list: (...args: unknown[]) => [...aiPromptsKeys.all, 'list', ...args] as const,
  item: (id: string) => [...aiPromptsKeys.all, 'item', id] as const,
};
